import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonPermissionList } from "./Common/CommonPermissionList";

const PermissionPage = () => {
	return (
		<PageWrapper title='Permissões'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonPermissionList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default PermissionPage;